module.exports = __webpack_public_path__ + "img/index-header-bg-02.be187ece.png";